import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, mapRefSubtext } from "helpers/row-logic-helper";

import { companyOwnersMapNestedRows } from "./section-property-company-owner-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  purchaseDate: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "List of Owners",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT_NESTED,
        mapNestedRows: data => companyOwnersMapNestedRows(data),
        map: row => defaultField(row, "name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [
          { map: row => mapRefSubtext(row, "percentAllocated") },
          { map: row => mapRefSubtext(row, "isExternalEquitySource") }
        ]
      }
    ]
  }
};
